import React, { useState, useEffect } from 'react';
import "./styles/UsuarioForm.css";
import SelectSearch from "react-select-search";
import "../pages/styles/SelectSearch.css";
import Notify from "./Notify";
import useRoles from '../helpers/useRoles';
import CheckboxToggle from './CheckboxToggle';
import { CampoInput } from './Campos';
import { BotonLetras } from './Plantillas/Botones';

const UsuarioFormEmpresa = ({ Usuario, closeModal }) => {
    const [usuario, setUsuario] = useState(Usuario.Usuario || "");
    const [password, setPassword] = useState(Usuario.password || "");
    const [passwordConfirm, setPasswordConfirm] = useState(Usuario.passwordConfirm || "");
    const [roles, setRoles] = useState(Usuario.Roles || []);
    const [IdSucursal, setIdSucursal] = useState(Usuario.IdSucursal || null);
    const [IdEmpleado, setIdEmpleado] = useState(Usuario.IdEmpleado || null);

    const [sucursales, setSucursales] = useState(null);
    const [empleados, setEmpleados] = useState(null);
    const [AllRoles, setAllRoles] = useState(null);

    // Obtener sucursales de la empresa del usuario autenticado
    useEffect(() => {

        const fetchRoles = async () => {
            try {
                const response = await fetch("/api/usuarios/roles");
                const roles = await response.json()
                setAllRoles(roles);
            } catch (error) {
                Notify("Error al cargar roles", "error");
            }
        };
        fetchRoles();

        const fetchSucursales = async () => {
            try {
                const response = await fetch("/api/sucursales/SucursalEmpresa");
                const data = await response.json();
                
                const sucursalesList = data.map(sucursal => ({
                    name: sucursal.Nombre,
                    value: sucursal.IdSucursal,
                    IdSucursal: sucursal.IdSucursal,
                    IdEmpresa: sucursal.IdEmpresa
                }));
                setSucursales(sucursalesList);
            } catch (error) {
                Notify("Error al cargar sucursales", "error");
            }
        };
        fetchSucursales();
    }, []);

    // Obtener empleados de la empresa
    useEffect(() => {
        const fetchEmpleados = async () => {
            try {
                const response = await fetch("/api/usuarios/empresa/empleados");
                const data = await response.json();
                
                if (data[0] && data[0][0] && Array.isArray(data[0][0])) {
                    const empleadosList = data[0][0].map(empleado => ({
                        name: `${empleado.Nombres} ${empleado.Apellidos}`,
                        value: empleado.IdEmpleado
                    }));
                    setEmpleados(empleadosList);
                }
            } catch (error) {
                Notify("Error al cargar empleados", "error");
            }
        };
        fetchEmpleados();
    }, []);

    const HandleRolBuilder = IdRol => {
        return event => {
            const isAdding = event.target.checked === true;
            const newRoles = [...roles];
            if (isAdding) {
                newRoles.push(IdRol);
            } else {
                const IdRolIndex = newRoles.indexOf(IdRol);
                newRoles.splice(IdRolIndex, 1);
            }
            setRoles(newRoles);
        };
    };

    const getRolesChanges = () => {
        const addList = [];
        const removeList = [...(Usuario.Roles || [])];
        roles.forEach(IdRol => {
            const IdRolIndex = removeList.indexOf(IdRol);
            if (IdRolIndex === -1) {
                addList.push(Number(IdRol));
            } else {
                removeList.splice(IdRolIndex, 1);
            }
        });
        return { addList, removeList };
    };

    const handleSubmit = async e => {
        e.preventDefault();
        
        if (password !== passwordConfirm) {
            return Notify("Contraseñas no concuerdan", "error", 1500);
        }

        const postUrl = Usuario.IdUsuario
            ? `/api/usuarios/empresa/${Usuario.IdUsuario}`
            : "/api/usuarios/empresa";

        const Roles = getRolesChanges();
        const data = { usuario, password, IdSucursal, IdEmpleado, Roles };

        try {
            const response = await fetch(postUrl, {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            });
            const result = await response.json();

            if (result.error) {
                return Notify(result.error, "error");
            }
            if (result._estado && result._estado !== true) {
                return Notify(result._estado, "error");
            }

            Notify("Usuario guardado exitosamente");
            closeModal();
        } catch (error) {
            Notify("Error al guardar usuario", "error");
        }
    };

    return (
        <form id="usuarios_form" action="/api/usuarios/empresa" method="POST" onSubmit={handleSubmit}>
            {sucursales && (
                <SelectSearch
                    value={IdSucursal}
                    onChange={e => setIdSucursal(e.value)}
                    options={sucursales}
                    name="IdSucursal"
                    placeholder="Sucursal"
                />
            )}
            {empleados && (
                <SelectSearch
                    value={IdEmpleado}
                    onChange={e => setIdEmpleado(e.value)}
                    options={empleados}
                    name="IdEmpleado"
                    placeholder="Empleado"
                />
            )}

            <CampoInput
                label="Nombre de Usuario"
                value={usuario}
                onChange={e => setUsuario(e.target.value)}
                name="username"
                type="text"
                autoComplete="username"
            />
            <CampoInput
                label="Contraseña"
                value={password}
                onChange={e => setPassword(e.target.value)}
                name="password"
                type="password"
                autoComplete="new-password"
            />
            <CampoInput
                label="Confirmar contraseña"
                value={passwordConfirm}
                onChange={e => setPasswordConfirm(e.target.value)}
                name="passwordConfirm"
                type="password"
                autoComplete="new-password"
            />

            <div className="roles">
                {AllRoles && AllRoles.map(rol => {
                    const { IdRol, Nombre } = rol;
                    const checked = roles.some(_IdRol => _IdRol === IdRol);
                    return (
                        <div key={IdRol} className="d-flex menu-nombre-width">
                            <CheckboxToggle
                                checked={checked}
                                onChange={HandleRolBuilder(IdRol)}
                                labelText={Nombre}
                            />
                        </div>
                    );
                })}
            </div>

            <BotonLetras className="mt-3" type="submit">
                {Usuario.IdUsuario ? "Actualizar" : "Guardar"}
            </BotonLetras>
        </form>
    );
};

export default UsuarioFormEmpresa;
